
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 341.3"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill":"#6DA544","d":"M0 0h512v341.3H0z"}}),_c('path',{attrs:{"fill":"#338AF3","d":"M512 0v166.7L0 170.8V0z"}}),_c('path',{attrs:{"fill":"#FFF","d":"M256 170.7L0 341.3V0z"}}),_c('path',{attrs:{"fill":"#D80027","d":"M89.8 92.5l17 52.4H162l-44.6 32.5 17 52.4-44.6-32.4-44.6 32.4 17-52.4-44.6-32.5h55.2z"}})])
          )
        }
      }
    